import PropTypes from "prop-types";
import React from "react";

import * as classes from "./desktop_only.module.scss";

export default function DesktopOnly({ children }) {
  return <div className={classes.desktopOnly}>{children}</div>;
}

DesktopOnly.propTypes = {
  children: PropTypes.node.isRequired,
};

DesktopOnly.defaultProps = {};
